import { Injectable } from '@angular/core';
import { SecureService } from './secure.service';

@Injectable({
    providedIn: 'root',
})
export class SessionStorageService {
    constructor(private secureService: SecureService) {}

    set(key: string, value: string): void {
        this.secureService.secureSessionStorage.setItem(key, JSON.stringify(value));
    }

    get(key: string): any {
        return JSON.parse(this.secureService.secureSessionStorage.getItem(key));
    }

    remove(key: string): void {
        this.secureService.secureSessionStorage.removeItem(key);
    }

    clear(): void {
        this.secureService.secureSessionStorage.clear();
    }
}
